import { Skeleton } from "primereact/skeleton";
import { ReactElement } from "react";

export const ExtrasLoading = (): ReactElement => {
    return (
        <div
            id="quotation-order-extras-loading"
            data-cy="quotation-order-extras-loading"
        >
            <Skeleton shape="rectangle" width="100%" height="43.4vh" />
        </div>
    );
};
